import AppHeaderWrapper from './AppHeader.styles'
import { AppHeaderProps } from './AppHeader.types'

const AppHeader = ({
  className = '',
  styles,
  children,
  ...props
}: AppHeaderProps) => (
  <AppHeaderWrapper
    className={`AppHeader ${className}`}
    data-testid="app-header"
    sx={styles}
    {...props}>
    {children}
  </AppHeaderWrapper>
)

export default AppHeader
